import type { Chunk } from "@engo/shared";
import { useTranslation } from "react-i18next";

export function ChunkList({ chunks }: { chunks: Chunk[] }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <p className="text-xs text-[var(--text-muted)]">{t("chunkEditor.chunksLabel")}</p>
      <div className="space-y-2">
        {chunks.map((chunk, index) => (
          <div key={index} className="rounded-lg border border-[var(--glass-border)] p-3">
            <div className="flex flex-wrap items-center gap-2">
              <p className="text-sm font-semibold text-[var(--text-primary)]">{chunk.text}</p>
              <span className="rounded-full bg-[var(--primary)]/10 px-2 py-0.5 text-xs text-[var(--accent)]">
                {t(`chunkType.${chunk.chunk_type}`)}
                {chunk.cefr_level ? ` · ${chunk.cefr_level}` : ""}
              </span>
            </div>
            <p className="mt-1 text-sm italic text-[var(--text-secondary)]">{chunk.example}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
